import logo from "assets/img/logo.png"
import Navbar from 'react-bootstrap/Navbar'
import Container from 'react-bootstrap/Container'
import {Nav} from "react-bootstrap";
import {Link, useLocation} from "react-router-dom";
import './styles.css';

function NavBar() {
    const location = useLocation();

    const isActive = (path: string) => {
        return location.pathname === path;
    };

    return (
        <Navbar 
            expand="lg" 
            className="navbar-custom" 
            fixed="top"
        >
            <Container>
                <Navbar.Brand as={Link} to="/">
                    <img src={logo} alt="Hidanko" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">
                        <Link 
                            className={`nav-link ${isActive('/tools') ? 'active' : ''}`} 
                            to="/tools"
                        >
                            Tools
                        </Link>
                        <Link 
                            className={`nav-link ${isActive('/music') ? 'active' : ''}`} 
                            to="/music"
                        >
                            Music
                        </Link>
                        <Link 
                            className={`nav-link ${isActive('/test') ? 'active' : ''}`} 
                            to="/test"
                        >
                            Test
                        </Link>
                        <Link 
                            className={`nav-link ${isActive('/contato') ? 'active' : ''}`} 
                            to="/contato"
                        >
                            Contato
                        </Link>
                        <Link 
                            className={`nav-link ${isActive('/teste') ? 'active' : ''}`} 
                            to="/teste"
                        >
                            Teste
                        </Link>
                    </Nav>
                    <Nav>
                        <Nav.Link href="#alguma">Alguma coisa</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavBar;